import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import Styles from "../../../Styles.module.css";
import clsx from "clsx";

export default function ConfirmCancelEventDialog({
  openConfirmCancelEventDialog,
  setOpenConfirmCancelEventDialog,
  cancelEvent,
}) {
  return (
    <Dialog fullWidth open={openConfirmCancelEventDialog}>
      <DialogTitle className={Styles.navyBlueColor}>
        <Typography variant="subtitle1">Cancel Event</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: 120 }}>
          Are you sure to cancel this event?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => setOpenConfirmCancelEventDialog(false)}
          className={Styles.navyBlueColorForce}
          style={{ textTransform: "capitalize", marginRight: 16 }}
        >
          No
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            if (cancelEvent) {
              cancelEvent(() => {
                setOpenConfirmCancelEventDialog(false);
              });
            }
          }}
          className={clsx(Styles.navyBlueColorForce, Styles.primaryBtnAccent)}
          style={{ textTransform: "capitalize" }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
